import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobTeamShareList } from '../../lib';

function RouteMobTeamsShareList(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ''}_pb8iga`} path={[`${parentPath}/mobile/uk/appshare/:userId`,`${parentPath}/mobile/uk/appshare`]}>
      {
        <MobTeamShareList weId={`${props.weId || ''}_kj0za7`}/>
      }
    </Route>
  )
}

export default withRouter(RouteMobTeamsShareList);